import {
  COUNTRY_CODE_REGEX,
  NEW_COUNTRY_CODE_REGEX,
  QUOTES_REGEX,
} from '@monoimin/constants';

export const normalizeTitle = (title: string) => {
  return title
    .replace(COUNTRY_CODE_REGEX, '')
    .replace(QUOTES_REGEX, '')
    .replace(NEW_COUNTRY_CODE_REGEX, '')
    .trim();
};
export default normalizeTitle;
